import React, { useEffect, useState } from 'react';
import { Typography } from '@mui/material';

const TICK_MS = 10_000;

const label = (updatedAt: Date, now: number): string => {
  const s = Math.max(0, Math.floor((now - updatedAt.getTime()) / 1000));
  if (s < 60) return `Updated ${s}s ago`;
  const m = Math.floor(s / 60);
  if (m < 60) return `Updated ${m}m ago`;
  return `Updated ${Math.floor(m / 60)}h ago`;
};

/** Relative "Updated Xs ago" caption; re-renders every 10s. Renders nothing until first data. */
const UpdatedStamp: React.FC<{ updatedAt: Date | null }> = ({ updatedAt }) => {
  const [now, setNow] = useState(() => Date.now());
  useEffect(() => {
    if (!updatedAt) return;
    const id = setInterval(() => setNow(Date.now()), TICK_MS);
    return () => clearInterval(id);
  }, [updatedAt]);
  if (!updatedAt) return null;
  return (
    <Typography variant="caption" color="text.secondary" sx={{ whiteSpace: 'nowrap' }}>
      {label(updatedAt, now)}
    </Typography>
  );
};

export default UpdatedStamp;
